import { extractEnumValue } from '@/models/enum.utils';

export const PROSPECT_JOURNEY = Object.freeze({
  PRODUCT_LED: {
    value: 'product_led',
  },
  SALES_LED: {
    value: 'sales_led',
  },
  SALES_ASSIST: {
    value: 'sales_assist',
  },
} as const);

export type ProspectJourneyEntry = (typeof PROSPECT_JOURNEY)[keyof typeof PROSPECT_JOURNEY];
export type ProspectJourneyValue = ProspectJourneyEntry['value'];

export function isSameProspectJourney(
  left: ProspectJourneyEntry | string,
  right: ProspectJourneyEntry | string,
): boolean {
  const leftType = extractEnumValue(left);
  const rightType = extractEnumValue(right);
  return leftType === rightType;
}
